import React, { Component } from 'react'
import {DateTime} from 'luxon'
import EventInfo from '../event-info'
import Header from '../page-header--event-single'
import VendorsIndex from '../vendors-index'
import Retailers from '../retailers'
import EventProgramCard from '../event-program-card'
import SponsorSection from '../event-sponsor-section'
import EventProgramCards from '../event-program-cards'
import { SwiperSlide } from 'swiper/react'
import Logos from './logos'
import FeaturedContent from './featured-content'

export default class EventPageContent extends Component {
  get program(){
    const { event, locationExtras } = this.props
    if( ! event ) return null
    let program = false
    let date = DateTime.fromString( event.date, 'yyyy-M-d' )
    date = date.toFormat('yyyy-MM-dd')
    if(
      typeof locationExtras !== 'undefined' &&
      typeof locationExtras.specialPrograms[ date ] !== 'undefined'
    ){
      program = this.props.locationExtras.specialPrograms[ date ]
    }
    return program
  }
  render (){
    const { market, event, locationExtras } = this.props
    let aboutCTA, banner, heroLogo, heroVideo, heroCTA, heroCTADarkSide, heroCTAGTMID, heroCTAAnalytics,
    sponsorSectionOptions, specialPrograms,
    specialProgramsHeading,
    heroCarousel

    if( locationExtras ){
      ({
        aboutCTA, banner, heroLogo, heroVideo, heroCTA, heroCTADarkSide,
        heroCTAGTMID, heroCTAAnalytics,
        sponsorSectionOptions, specialPrograms, specialProgramsHeading, heroCarousel
      } = locationExtras)
    }
    let programs = [];
    let program_keys = specialPrograms ? Object.keys(specialPrograms) : [];
    
    const vendors = Object.values(Object.groupBy([...event.vendors, ...event.creators], 
      ({ id }) => id)).map(e => e.reduce((acc, cur) => ({ ...acc, ...cur }))
    );

    const retailers = event.retailers.length ? event.retailers : []

    const structuredData = { __html: JSON.stringify( {
      '@context': "https://schema.org",
      '@type': "FoodEvent",
      "additionalType": "SocialEvent",
      location: {
        '@type': "Place",
        name: market.name,
        address: {
          '@type': "PostalAddress",
          streetAddress: market.address,
          addressLocality: market.city,
          addressRegion: market.state,
        }
      },
      name: `Off The Grid - ${market.name}`,
      startDate: event.startTime._date,
      endDate: event.endTime._date,
      image: market.imageUrl,
      description: market.about,
    } ) }

    program_keys.sort()

    program_keys.forEach((key) => programs.push(specialPrograms[key]) );

    programs = programs.map( (program, idx) => {
      return (
        <SwiperSlide key={ idx }>
          <EventProgramCard className="slide" { ...program }  />
        </SwiperSlide>
      );
    })

    return (
      <div>
        <script type="application/ld+json" dangerouslySetInnerHTML={ structuredData } />
        <Header
          heading={ event.name }
          locationExtras={locationExtras}
          market={market}
          logo={ heroLogo }
          video={ heroVideo }
          carousel={ heroCarousel }
          cta={ heroCTA }
          ctaDarkSide={ heroCTADarkSide }
          ctaID={ heroCTAGTMID }
          ctaAnalytics={ heroCTAAnalytics }
        />
        <EventInfo
          banner={ banner }
          aboutCTA={ aboutCTA }
          event={ this.props.event }
          market={this.props.market}
          setEvent={this.props.setEvent}
        />
        { programs.length > 0 &&
        <EventProgramCards heading={ specialProgramsHeading }>
          {programs}
        </EventProgramCards> }
        <Logos />
        {<SponsorSection {...sponsorSectionOptions} />}

        { this.props.locationExtras &&
          locationExtras.cta_button &&
          <section className='location-cta' >
            <h3 className='text'>
              { this.props.locationExtras.cta_text }
            </h3>
            {	locationExtras.cta_button &&
              locationExtras.cta_button.url &&
              locationExtras.cta_button.text &&
              <a
                className={'button button--small'}
                href={locationExtras.cta_button.url}
                >
                {locationExtras.cta_button.text}
              </a>
            }
          </section>
        }
        <section id="creators">
          <h2 className="highlight">Food Schedule</h2>
          <VendorsIndex vendors={ vendors } market={ market } compactGrid={true} initialPageLength={50} />
        </section>
        <section id="retailers">
          {
            retailers.length > 0 &&
            <h2 className="highlight">Shops</h2>
          }
          <Retailers retailers={ retailers } market={ market } compactGrid={true} initialPageLength={50} />
        </section>
        <FeaturedContent />
      </div>
    )
  }
}
